/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import { computed } from '@vue/composition-api';
import Cookies from 'js-cookie';
import EventBus from '@/assets/js/utils/EventBus';

const MODAL_NAME = 'ui-modal-reel';
const SHOW_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
const AGE_CHECK_COOKIE = 'ageCheck';

/**
 * Composable for managing DX Reel modal functionality
 * @param {Object} store - Vuex store instance
 * @param {Object} modal - Vue modal instance
 */
export default function useDxReel(store, modal) {
  const lastClosedAt = computed(() => store.state.modal.lastClosedAt);
  const userIsSiteMember = computed(() => store.getters['user/isSiteMember']);

  const shouldShowModal = () => {
    const hasCookie = Cookies.get(AGE_CHECK_COOKIE);
    const timerCondition = !lastClosedAt.value || (Date.now() - lastClosedAt.value >= SHOW_INTERVAL_MS);
    return hasCookie && timerCondition;
  };

  const timeUntilShow = () => (lastClosedAt.value
    ? Math.max(0, SHOW_INTERVAL_MS - (Date.now() - lastClosedAt.value))
    : 0);

  const showModal = () => modal.show(MODAL_NAME);
  const hideModal = () => modal.hide(MODAL_NAME);

  const closeAndScheduleNext = () => {
    hideModal();
    store.dispatch('modal/setLastClosed');
    setTimeout(showModal, timeUntilShow());
  };

  const tryToShowModal = () => {
    if (shouldShowModal()) {
      showModal();
    } else {
      const delay = timeUntilShow();
      setTimeout(showModal, delay);
    }
  };

  const initialize = () => {
    // Set up event listener for age verification acknowledgement
    EventBus.$on('agecheck:acknowledged', tryToShowModal);

    // Only proceed if user already has age check cookie
    if (!Cookies.get(AGE_CHECK_COOKIE)) {
      return;
    }

    tryToShowModal();
  };

  return {
    userIsSiteMember,
    closeReelModal: closeAndScheduleNext,
    initializeReelModal: initialize,
  };
}
